@if (display_items().length === 0) {
  <p class="empty-message">Este examen no tiene preguntas.</p>
} @else {
  @if (has_total_minutes()) {
    <p class="total-exam-minutes">
      Tiempo total del examen: <strong>{{ total_exam_minutes() }} min</strong>
    </p>
  }

  <mat-accordion multi>
    @for (display_item of display_items(); track display_item.id) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="item-order">{{ display_item.sort_order + 1 }}.</span>
            {{ display_item.question_body }}
          </mat-panel-title>
          <mat-panel-description>
            <span class="item-meta">
              {{ display_item.minutes_label }} · {{ display_item.type_label }} · Peso {{ display_item.weight }}
            </span>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <p class="question-body">{{ display_item.question_body }}</p>

        @if (display_item.approximate_minutes) {
          <p><strong>Tiempo estimado:</strong> {{ display_item.minutes_label }}</p>
        }

        @if (display_item.answer_lines) {
          <p><strong>Líneas de respuesta:</strong> {{ display_item.answer_lines }}</p>
        }

        @if (display_item.options_display !== '—') {
          <p><strong>Opciones:</strong> {{ display_item.options_display }}</p>
        }

        @if (display_item.has_rubric_matrix) {
          <div class="rubric-matrix-wrapper">
            <h3 class="rubric-title">Rúbrica</h3>
            <table class="rubric-matrix-table">
              <thead>
                <tr>
                  <th class="corner-cell"></th>
                  @for (level of display_item.sorted_rubric_levels; track level.id ?? $index) {
                    <th>
                      <div class="matrix-header-cell">
                        <span class="matrix-header-name">{{ level.name }}</span>
                        <span class="matrix-header-percent">{{ level.weight_percent }} %</span>
                      </div>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (matrix_row of display_item.rubric_matrix_rows; track matrix_row.dimension_name) {
                  <tr>
                    <th class="row-header-cell">
                      <div class="matrix-header-cell">
                        <span class="matrix-header-name">{{ matrix_row.dimension_name }}</span>
                        <span class="matrix-header-percent">{{ matrix_row.dimension_weight_percent }} %</span>
                      </div>
                    </th>
                    @for (cell of matrix_row.cells; track cell.level_name) {
                      <td>
                        <div class="matrix-cell">
                          <span class="matrix-cell-percent">{{ cell.cell_weight_percent }} %</span>
                          <p class="matrix-cell-rules">{{ cell.rules }}</p>
                        </div>
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
}
